export default __webpack_public_path__ + "maps-examples-add-marker-symbol-1200-b792f1d81359ca4f27dc2b304be29462.webp";